(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-player"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseTime = (value) => {
      const parts = value.trim().replace(',', '.').split(':').map(Number);
      if (parts.some(Number.isNaN)) return null;
      return parts.length === 3
        ? parts[0] * 3600 + parts[1] * 60 + parts[2]
        : parts[0] * 60 + parts[1];
    };

    const parseVtt = (text) => {
      const cues = [];
      const blocks = text.replace(/^\uFEFF/, '').split(/\r?\n\r?\n+/);
      blocks.forEach((block) => {
        const lines = block.trim().split(/\r?\n/);
        const timingIndex = lines.findIndex((line) => line.includes('-->'));
        if (timingIndex < 0) return;
        const times = lines[timingIndex].split('-->').map((time) => parseTime(time.split(/\s+/)[0]));
        if (times[0] === null || times[1] === null) return;
        cues.push({ start: times[0], end: times[1], text: lines.slice(timingIndex + 1).join('\n') });
      });
      return cues;
    };

    const parseLrc = (text) => {
      const cues = [];
      text.split(/\r?\n/).forEach((line) => {
        const matches = [...line.matchAll(/\[(\d{1,3}:\d{2}(?:\.\d{1,3})?)\]/g)];
        const lyric = line.replace(/\[[^\]]+\]/g, '').trim();
        matches.forEach((match) => {
          const start = parseTime(match[1]);
          if (start !== null && lyric) cues.push({ start, end: Infinity, text: lyric });
        });
      });
      cues.sort((a, b) => a.start - b.start);
      cues.forEach((cue, index) => { cue.end = cues[index + 1]?.start || Infinity; });
      return cues;
    };

    const init = (root) => {
      const audio = root.querySelector('[data-music-player]');
      const output = root.querySelector('[data-lyrics]');
      if (!audio || !output || root.dataset.musicPlayerReady === 'true') return;
      root.dataset.musicPlayerReady = 'true';

      const url = output.dataset.lyricsUrl;
      const format = output.dataset.lyricsFormat;
      if (!url) return;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Lyrics could not be loaded');
          return response.text();
        })
        .then((text) => {
          const cues = format === 'lrc' ? parseLrc(text) : parseVtt(text);
          if (!cues.length) return;
          const update = () => {
            const cue = cues.find(({ start, end }) => audio.currentTime >= start && audio.currentTime < end);
            output.textContent = cue?.text || '';
          };
          audio.addEventListener('timeupdate', update);
          audio.addEventListener('seeked', update);
          update();
        })
        .catch(() => {
          if (!output.textContent.trim()) output.remove();
        });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('.music-player-section').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
